import { Encoder, Utils } from '@everyboard/lib';
import { Player, PlayerOrNone } from '../../jscaip/Player';
import { PlayerMap } from '../../jscaip/PlayerMap';
export class YinshPiece {
    player;
    isRing;
    static encoder = Encoder.tuple([PlayerOrNone.encoder, Encoder.identity()], (piece) => [piece.player, piece.isRing], (fields) => YinshPiece.of(fields[0], fields[1]));
    static UNREACHABLE = new YinshPiece(PlayerOrNone.NONE, false);
    static EMPTY = new YinshPiece(PlayerOrNone.NONE, false);
    static MARKER_ZERO = new YinshPiece(Player.ZERO, false);
    static MARKER_ONE = new YinshPiece(Player.ONE, false);
    static MARKERS = PlayerMap.ofValues(YinshPiece.MARKER_ZERO, YinshPiece.MARKER_ONE);
    static RING_ZERO = new YinshPiece(Player.ZERO, true);
    static RING_ONE = new YinshPiece(Player.ONE, true);
    static RINGS = PlayerMap.ofValues(YinshPiece.RING_ZERO, YinshPiece.RING_ONE);
    static of(playerOrNone, isRing) {
        if (playerOrNone.isNone()) {
            return YinshPiece.EMPTY;
        }
        else {
            const player = playerOrNone;
            if (isRing) {
                return YinshPiece.RINGS.get(player);
            }
            else {
                return YinshPiece.MARKERS.get(player);
            }
        }
    }
    constructor(player, isRing) {
        this.player = player;
        this.isRing = isRing;
    }
    equals(piece) {
        return this === piece;
    }
    flip() {
        Utils.assert(this.isRing === false, 'cannot flip a ring (it should never happen)');
        Utils.assert(this.player.isPlayer(), 'cannot flip a non-player piece');
        const player = this.player;
        return YinshPiece.of(player.getOpponent(), this.isRing);
    }
    toString() {
        switch (this) {
            case YinshPiece.UNREACHABLE: return 'NONE';
            case YinshPiece.EMPTY: return 'EMPTY';
            case YinshPiece.MARKER_ZERO: return 'MARKER_ZERO';
            case YinshPiece.MARKER_ONE: return 'MARKER_ONE';
            case YinshPiece.RING_ZERO: return 'RING_ZERO';
            default:
                Utils.expectToBe(this, YinshPiece.RING_ONE);
                return 'RING_ONE';
        }
    }
    isReachable() {
        return this !== YinshPiece.UNREACHABLE;
    }
    isMarker() {
        return this === YinshPiece.MARKER_ZERO ||
            this === YinshPiece.MARKER_ONE;
    }
}
